import React from 'react'

import { Row } from '../Grid'
import { Text } from '../Text'
import { Info } from '../Icons'

const WarningToast = ({ closeToast }) => (
  <Row alignItems='center' justifyContent='space-between'>
    <Row alignItems='center'>
      <Info color='#fff' size={20} />
      <Text color='white' ml='8px' variant='small'>
        Você selecionou pelo menos 2 consultas para a mesma semana
      </Text>
    </Row>
    <Text textDecoration='underline' color='white' variant='small' onClick={closeToast}>
      OK!
    </Text>
  </Row>
)

export default WarningToast
